/* eslint-disable */
import React, { useState } from "react";
import Body from "./Body";

const Dashboard = () => {
  const [lineChartData, setLineChartData] = useState([
    { name: "Jan", profit: 18473 },
    { name: "Feb", profit: 92035 },
    { name: "Mar", profit: 67102 },
    { name: "Apr", profit: 53897 },
    { name: "May", profit: 30216 },
    { name: "June", profit: 74651 },
    { name: "July", profit: 80942 },
    { name: "Aug", profit: 12387 },
    { name: "Sept", profit: 49528 },
    { name: "Oct", profit: 66749 },
    { name: "Nov", profit: 25891 },
    { name: "Dec", profit: 37904 },
  ]);

  const [horizontalBarChartData, setHorizontalBarChartData] = useState([
    { name: "revenue", value: 250000 },
    { name: "expenses", value: 75000 },
    { name: "liabilities", value: 150000 },
  ]);

  const [cashInFlowPieChartData, setCashInFlowPieChartData] = useState([
    { name: "Group A", value: 400 },
    { name: "Group B", value: 300 },
    { name: "Group C", value: 300 },
    { name: "Group D", value: 200 },
  ]);
  const [cashOutFlowPieChartData, setCashOutFlowPieChartData] = useState([
    { name: "Group A", value: 200 },
    { name: "Group B", value: 400 },
    { name: "Group C", value: 300 },
    { name: "Group D", value: 300 },
  ]);

  const [cashFlowData, setCashFlowData] = useState({
    cashInFlow: {
      title: "Cash InFlow",
      amount: "39,00,000",
      percentageChange: "+3.4%",
      note: "Good For Business",
      noteColor: "color-greenColor",
    },
    cashOutFlow: {
      title: "Cash OutFlow",
      amount: "39,00,000",
      percentageChange: "-3.4%",
      note: "Good For Business",
      noteColor: "color-greenColor",
    },
  });

  const _this = {
    lineChartData,
    horizontalBarChartData,
    cashInFlowPieChartData,
    cashOutFlowPieChartData,
    cashFlowData,
  };
  return <Body {..._this} />;
};

export default Dashboard;
